import React from 'react';
import { useSiteDialogComponents } from '../../hooks/site-dialog/useSiteDialogComponents';
import { useSiteContext } from '../../SiteContext';
import { SiteEventDialogConfigurator } from './SiteEventOpenDialogPlugin';
export const SiteEventCloseDialogPlugin = {
    name: 'Close Dialog',
    type: 'dialog-close',
    eventTypes: ['onClick', 'onDialogClose'],
    configurator: SiteEventDialogConfigurator,
    getConfigSummary: event => {
        const ConfigSummary = () => {
            var _a;
            const dialogs = useSiteDialogComponents();
            const dialog = dialogs.find(d => { var _a; return d.id === ((_a = event === null || event === void 0 ? void 0 : event.config) === null || _a === void 0 ? void 0 : _a.dialogId); });
            const title = (_a = dialog === null || dialog === void 0 ? void 0 : dialog.props) === null || _a === void 0 ? void 0 : _a.title;
            return dialog ? (React.createElement(React.Fragment, null,
                "Close dialog \"",
                React.createElement("span", { title: title ? dialog.name : undefined }, title || dialog.name),
                "\"")) : (React.createElement(React.Fragment, null, "Dialog not found."));
        };
        return React.createElement(ConfigSummary, null);
    },
    handler: (config, context) => {
        const { dialogs, closeDialog } = context.hook;
        const dialog = dialogs.find(d => d.id === config.dialogId);
        if (dialog) {
            closeDialog(context.componentId, dialog);
        }
        else {
            console.warn('Dialog not found.');
        }
    },
    useHook: () => {
        const { closeDialog } = useSiteContext();
        const dialogs = useSiteDialogComponents();
        return { dialogs, closeDialog };
    }
};
//# sourceMappingURL=SiteEventCloseDialogPlugin.js.map